import { defineFcm } from '../shared/factory';

export const FCM_MOVEMENT_PETITION_ADD_NOTIFICATION = defineFcm('movement_petition_add_notification')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Flag to enable/disable the email notification for petitions being added to a movement.',
		import: false,
	});
